module.exports = __webpack_public_path__ + "img/image55.8811e574.png";